import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserFullInfoService } from '@core/services/user-full-info.service';

export const canActivateAdmin: CanActivateFn = async () => {
  const userService = inject(UserFullInfoService);
  const router = inject(Router);

  const user = await userService.loadUserInfo();

  return user?.isAdmin ? true : router.createUrlTree(['/']);
};
